import _ from 'lodash';
import { noCredentials as http } from 'helpers/axios';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import User from '../components/User';

const $lifecycle = lifecycle({
  componentDidMount() {
    const { history, match } = this.props;
    const token = _.get(match, 'params.token');
    if (!token) {
      return history.push('/dashboard');
    }

    this.props.setToken(token);

    http
      .get(`/invites/resolve/${token}`)
      .then(({ data }) => {
        this.props.setInvite(data);
        this.props.updateLoading(false);
      })
      .catch(error => {
        const { status } = error.response;
        if (status === 403) {
          const { data } = error.response;
          let message = 'internal error';
          if (data.message) {
            // Remove moleculer NodeID error
            message = _.replace(data.message, /\(Node.*/, '');
          }
          this.props.setError(message);
          this.props.updateLoading(false);
        }
      });
  },
});

const enhance = compose(
  withState('loading', 'updateLoading', true),
  withState('error', 'setError'),
  withState('invite', 'setInvite'),
  withState('token', 'setToken'),
  withHandlers({
    onComplete: props => () => {
      props.history.push('/dashboard');
    },
  }),
  $lifecycle
);

export default enhance(User);
